export enum MiddleOfficeButtonType {
  EDIT_HERO = 'EH',
  EDIT_STORE_SCHEDULES = 'ESS',
  EDIT_EXCEPTIONAL_STORE_SCHEDULES = 'EESS',
  EDIT_REALISATIONS = 'ER',
  ADD_REALISATION = 'AR',
  EDIT_GALLERY = 'EG',
}
